import { QueryObserverOptions, useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
import { errorMessage } from '@api/messages';
import { countCommentsByUploadId } from '../api';

type UseQueryOptionsKeys = Pick<QueryObserverOptions<number>, 'enabled'>;

export default function useCountComments(id: number, options?: UseQueryOptionsKeys) {
  const { t } = useTranslation();
  const { data, isFetching } = useQuery(['commentsCount', id], () => countCommentsByUploadId(id), {
    onError: error => {
      errorMessage({
        title: t('error.fetching.comments'),
        message: null,
        error,
      });
    },
    ...options,
  });

  return { commentsCount: data, isFetching };
}
